import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AppIcon } from '@backrs_ui/common-ui/src/designSystem/icons/AppIcon';
import { TIERS, TRACK_CODE_TO_NAME } from '@backrs_ui/common-ui/src/models/careerPath';
import { TIER_KEY_TO_COLOR } from '@backrs_ui/common-ui/src/utils/careerTrack.util';
import { Avatar, Box } from '@mui/material';
var TRACK_ORDER = [TIERS.SEMISKILLED, TIERS.TRADE, TIERS.MID, TIERS.UPPER, TIERS.TOP];
export var HorizontalCareerTrackBar = function (_a) {
    var currentTrack = _a.currentTrack, profileImageUrl = _a.profileImageUrl;
    var currentTrackName = TRACK_CODE_TO_NAME[currentTrack];
    var currentTrackIndex = TRACK_ORDER.indexOf(currentTrackName) || 0;
    var previousTrackIndex = currentTrackIndex - 1;
    return (_jsxs(Box, { sx: outerContainerSx, children: [_jsx(Box, { sx: containerSx, children: TRACK_ORDER.map(function (track, index) {
                    var isHighlighted = index === currentTrackIndex || index === previousTrackIndex;
                    var trackKey = Object.keys(TIERS).find(function (key) { return TIERS[key] === track; });
                    var trackColor = TIER_KEY_TO_COLOR[trackKey];
                    return _jsx(Box, { sx: segmentSx(isHighlighted, trackColor) }, track);
                }) }), _jsx(Box, { sx: profileImageContainerSx(currentTrackIndex), children: profileImageUrl ? (_jsx(Avatar, { src: profileImageUrl, sx: profileImageSx })) : (_jsx(Box, { sx: profileImageSx, children: _jsx(AppIcon, { iconName: "User01", diameter: "28px", color: "Colors/Foreground/fg-quaternary" }) })) })] }));
};
var outerContainerSx = {
    position: 'relative',
    width: '100%',
};
var containerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        position: 'relative',
        display: 'flex',
        width: '100%',
        height: '20px',
        borderRadius: '10px',
        border: "1px solid ".concat(backrs.colors['Colors/Base/Black']),
        overflow: 'hidden',
    });
};
var segmentSx = function (isHighlighted, color) {
    return function (_a) {
        var backrs = _a.backrs;
        return ({
            flex: 1,
            height: '100%',
            backgroundColor: isHighlighted
                ? backrs.colors[color]
                : backrs.colors['Colors/Background/bg-quaternary'],
            borderRight: "1px solid ".concat(backrs.colors['Colors/Base/Black']),
            '&:last-child': {
                borderRight: 'none',
            },
        });
    };
};
var profileImageContainerSx = function (currentTrackIndex) { return ({
    position: 'absolute',
    left: "".concat((currentTrackIndex / TRACK_ORDER.length) * 100, "%"),
    top: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 2,
}); };
var profileImageSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        backgroundColor: backrs.colors['Colors/Background/bg-tertiary'],
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '40px',
        height: '40px',
        borderRadius: backrs.radius['radius-full'],
        border: "1px solid ".concat(backrs.colors['Colors/Base/Black']),
    });
};
